import { animate, style, transition, trigger } from "@angular/animations";

export const fadeHeightAnimation = trigger('fadeHeightAnimation', [
  transition(':enter', [
    style({ opacity: 0, height: '0' }),
    animate('225ms ease-out', style({ opacity: 1, height: '*' })),
  ]),
  transition(':leave', [
    style({ opacity: 1, height: '*' }),
    animate('225ms ease-out', style({ opacity: 0, height: '0' })),
  ]),
]);